<template>
  <div>
    <div class="logo" v-show="true || $vuetify.breakpoint.smAndUp" :style="logoStyle"></div>
    <v-navigation-drawer fixed :clipped="true" app disable-resize-watcher stateless :value="sidebarVisible" width="220" style="margin-bottom: 100px;">
      <v-list dense class="sideBar">
        <template v-for="item in menuItems">
          <v-list-group v-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" @click="selectMenu(child)">
              <v-list-tile-action v-if="child.icon">
                <v-icon :size="child.icon.startsWith('fa-') ? 16 : 22">{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :style="currentItemKey === child.key ? 'font-weight: bold;' : ''">
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else @click="selectMenu(item)" :key="item.text" :class="item.key ? 'menuAction_' + item.key : ''">
            <v-list-tile-action>
              <v-icon :size="item.icon.startsWith('fa-') ? 16 : 22">{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title :style="currentItemKey === item.key ? 'font-weight: bold;' : ''">
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      date: new Date()
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('session/logout')
      this.$store.dispatch('page/setSidebarItem', {})
      this.$router.push({name: 'Login'})
    },
    selectMenu (menu) {
      if (menu.key === 'logout') {
        this.logout()
      } else if (menu.routerName) {
        this.$router.push({name: menu.routerName})
      } else {
        this.$router.push({name: 'Main'})
      }
    }
  },
  computed: {
    sidebarVisible: function () {
      return this.$store.state.sidebar.visible
    },
    menuItems: function () {
      // let roles = this.$store.state.session.roles
      // console.log('Filter sidebar items by roles: ' + roles)
      return this.$store.state.sidebar.items.filter(i => i.visible && (!i.role || this.$store.getters['session/hasRole'](i.role)))
    },
    logoStyle: function () {
      return this.$store.state.sidebar.visible ? 'left: 0;' : 'left: -250px;'
    },
    currentItemKey: function () {
      return this.$store.state.page.sidebarItemKey
    }
  }
}
</script>

<style scoped>
  .v-navigation-drawer {
    height: calc(100vh - 160px) !important;
    max-height: calc(100vh - 160px) !important;
  }
  div.logo {
    background-color: white;
    position: fixed;
    left: 0;
    top: calc(100vh - 100px);
    width: 220px;
    height: 70px;
    z-index: 10;
    background-image: url(/static/logo.png);
    background-repeat: no-repeat;
    background-position: 35px 15px;
    background-size: 140px;
    border-right: 1px solid rgba(0,0,0,.12);
    transition: left .2s cubic-bezier(.4,0,.2,1);
  }
  i.fa-tag {
    padding-left: 3px;
  }
  i.fa-id-badge {
    padding-left: 4px;
  }
  .v-list__tile__action, .v-list__tile__avatar {
    min-width: 42px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue